export default "__VITE_ASSET__CMISP$J___"